// eslint-disable-next-line import/no-extraneous-dependencies
import React from 'react';
import { dateFormat, priceFormat } from '@cashew/utils';
import cn from 'classnames';
import Tag from '@cashew/tag';
import './index.css';

const ns = 'list-item';

export type RenewalItemType = {
  data: {
    id: number;
    purchaseDate: string;
    orderDate: string;
    status: string;
    totalAmount: number;
    currencyCode: string;
    isBalance: boolean;
    merchantName: string;
    storeName: string;
    merchantOrderCode: string;
    nextPaymentDate: string;
    orderReference: string;
    productName?: string;
    activityDate: string;
    customerEmail?: string;
    customerFirstName?: string;
    customerLastName?: string;

    type?: any;
  };
  t: any;
  // eslint-disable-next-line react/require-default-props
  isOffline?: boolean;
};

export default ({
  data: {
    id,
    storeName,
    purchaseDate,
    status,
    totalAmount,
    currencyCode,
    isBalance = false,
    orderReference,
    nextPaymentDate,
    // customerEmail,
    customerFirstName,
    customerLastName,
    type = 'customer',
    activityDate,
  },
  t,
  isOffline = false,
}: RenewalItemType) => (
  <>
    <div className={ns}>
      {type !== 'customer' && (
        <div className="customer-name">
          <p>{[customerFirstName, customerLastName].join(' ')}</p>
        </div>
      )}
      {/* {type !== 'customer' && ( */}
      {/* <div> */}
      {/*  <p className="three-dots" title={customerEmail}>{customerEmail}</p> */}
      {/* </div> */}
      {/* )} */}
      {type === 'customer' && (
        <div className="merchant">
          <p className="store-name">{storeName}</p>
        </div>
      )}
      <div className="purchase-date">
        <p>{dateFormat({ date: purchaseDate })}</p>
      </div>
      <div className="id">
        <p>{id}</p>
      </div>
      {isOffline && (
        <div className="order-reference">
          <p>{orderReference}</p>
        </div>
      )}

      <div className="item-status">
        <Tag status={status}>{t(`status.${status}`)}</Tag>
      </div>
      {type !== 'customer' && (
        <div className="last-activity-date">
          <p>{dateFormat({ date: activityDate })}</p>
        </div>
      )}
      <div className="next-payment-date">
        <p>
          {nextPaymentDate && status !== 'CANCELLED'
            ? dateFormat({ date: nextPaymentDate })
            : ''}
        </p>
      </div>

      <div className="item-amount">
        <span
          className={cn({
            [`${ns}--positive`]: isBalance && totalAmount > 0,
            [`${ns}--negative`]: isBalance && totalAmount < 0,
          })}
        >
          {priceFormat({
            currency: currencyCode,
            amount: totalAmount,
            isBalance,
          })}
        </span>
      </div>
    </div>
  </>
);
